export const getBoardIdFromUrlOrEnvironment = (id?: string | undefined) => {
  if (process.env.VITE_LOCAL_BOARD_ID) {
    return process.env.VITE_LOCAL_BOARD_ID;
  }

  const location = globalThis.location;
  if (!location) {
    return id;
  }

  const url = new URL(location.href);

  const boardPathPattern = /\/(?:whiteboard|slides?)\//;

  const hash = url.hash;
  if (boardPathPattern.test(hash)) {
    const hashId = hash.split(boardPathPattern).pop();
    if (hashId) {
      return hashId;
    }
  }

  const path = url.pathname;
  if (boardPathPattern.test(path)) {
    const pathId = path.split(boardPathPattern).pop();
    if (pathId) {
      return pathId;
    }
  }

  return id;
};
